import { render, staticRenderFns } from "./EnderecoEstadoField.vue?vue&type=template&id=5b5dee84&scoped=true&"
import script from "./EnderecoEstadoField.vue?vue&type=script&lang=js&"
export * from "./EnderecoEstadoField.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoEstadoField.vue?vue&type=style&index=0&id=5b5dee84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5dee84",
  null
  
)

export default component.exports